import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import StreamControl from './StreamControl'
import { useDispatch } from 'react-redux'
import { State } from '../../../dataStore/reducers/reducerType'
import { setAutoSpotlight, setMediaType } from '../../../dataStore/actions/room/room'
import { mediaType as MediaType } from '@bt-react/constants'
import audit from '../../../lib/audit/audit'

const StreamControlIndex: FC = () => {
  const isPresenterLayoutsActive = useSelector((state: State) => state.layouts.presenterLayout.presenterLayoutsActive) as boolean
  const userData = useSelector((state: State) => state.user.data)
  const dispatch = useDispatch<any>()

  const onStreamControlBtnClick = () => {
    audit.addEntry('PresenterService', 'StreamEndClicked', JSON.stringify({
      userId: userData?.externalIdV2,
      name: `${userData?.firstName} ${userData?.lastName}`,
      localTimestamp: Date.now().toString(),
      cookies: document.cookie,
      browser: {
        vendor: navigator.vendor,
        userAgent: navigator.userAgent
      }
    }))
    if (!isPresenterLayoutsActive) return dispatch(setMediaType(MediaType.WEBCAM))

    dispatch(setAutoSpotlight(true))
    dispatch(setMediaType(MediaType.SPOTLIGHT))

  }

  return <StreamControl onStreamControlBtnClick={onStreamControlBtnClick} />
}

export default StreamControlIndex